import React, {
    useContext,
    useMemo
} from "react";
import {
    Button,
    Spinner
} from "react-bootstrap";
import SimpleMDEEditor from "react-simplemde-editor";
import PropTypes from "prop-types";

import ShopsContext from "../../../context/ShopsContext";
import ProductDescriptionMarkdown from "../../../components/ProductDescriptionMarkdown";
import normalizeCategorySlug from "../../../utilities/normalizeCategorySlug";

function CategoryForm({ state, onChange, onSave, loading, submitLabel, previewCategoryId }) {
    const shopsContext = useContext(ShopsContext);

    const normalizedSlug = useMemo(() => {
        return normalizeCategorySlug(state.slug);
    }, [state.slug]);
    const previewUrl = useMemo(() => {
        if(normalizedSlug.length === 0) {
            return null;
        }
        return shopsContext.currentShop.url + "/category/" + previewCategoryId + "/" + normalizedSlug;
    }, [normalizedSlug, previewCategoryId, shopsContext.currentShop.url]);

    const simpleMdeOptions = useMemo(() => {
        return {
            spellChecker: false,
            autoDownloadFontAwesome: false,
            toolbar: ["bold", "italic", "heading", "|", "quote", "unordered-list", "ordered-list", "|", "link", "horizontal-rule", "|", "guide"]
        }
    }, []);
    const onDescriptionChange = useMemo(() => {
        return (value) => {
            onChange({ description: value });
        }
    }, [onChange]);

    return (
        <React.Fragment>
            <div className="card mb-3">
                <div className="card-body">
                    <h4>Categorie informatie</h4>
                    <div className="form-group">
                        <label htmlFor="title">Titel</label>
                        <input
                            type="text"
                            className="form-control"
                            id="title"
                            value={ state.title }
                            onChange={ (event) => onChange({ title: event.target.value }) }
                            disabled={ loading }
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="slug">Slug</label>
                        <input
                            type="text"
                            className="form-control"
                            id="slug"
                            value={ state.slug }
                            onChange={ (event) => onChange({ slug: event.target.value }) }
                            disabled={ loading }
                        />
                        { previewUrl && (
                            <small className="form-text text-muted">
                                Resultaat: { previewUrl }
                            </small>
                        )}
                    </div>
                    <div className="form-group mb-0">
                        <label>Beschrijving</label>
                        <div className="row">
                            <div className="col-xl">
                                <SimpleMDEEditor
                                    value={ state.description }
                                    onChange={ onDescriptionChange }
                                    options={ simpleMdeOptions }
                                />
                            </div>
                            <div className="col-md">
                                <h5>Resultaat</h5>
                                <ProductDescriptionMarkdown>
                                    { state.description }
                                </ProductDescriptionMarkdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-end">
                <Button variant="primary" onClick={ onSave } disabled={ loading }>
                    { loading && (
                        <Spinner animation="border" size="sm" className="mr-2"/>
                    )}
                    { submitLabel }
                </Button>
            </div>
        </React.Fragment>
    );
}
CategoryForm.propTypes = {
    state: PropTypes.shape({
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    submitLabel: PropTypes.string,
    previewCategoryId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ])
}
CategoryForm.defaultProps = {
    loading: false,
    submitLabel: "Opslaan",
    previewCategoryId: "x"
}

export default React.memo(CategoryForm);
